import { FilterState } from "./types";
import { AlarmFilterEnum } from '../AlarmFilterEnum';
import { OrderFilterEnum } from '../OrderFilterEnum';
import { UserTags } from "@Safemate/enums/UserTags";


export interface PersistedFilters{
  deviceTypes: number[];
  customers: number[];
  alarmFilters: AlarmFilterEnum[];
  orderFilter: OrderFilterEnum;
  userTags: UserTags[];
}

export const loadFilters = (role: number, user: number): PersistedFilters => {
  try {
    const serializedState = localStorage.getItem(`role${role}_user${user}_device_list_filter`);
    if (serializedState === null) {
      return;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return;
  }
}; 

export const saveFilters = (state: PersistedFilters, role: number, user: number) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(`role${role}_user${user}_device_list_filter`, serializedState);
  } catch {
    // ignore write errors
  }
};